import React from 'react'
import lang from '@/lang'
import QRCode from 'react-qr-code'
import clsx from 'clsx'
import { formatMoney } from '@/modules/react/util'
import { CssHelper } from '@/modules/base/view/mixin/helpers_mixin'
import { makeStyles } from '@mui/styles'
import ThemeInterface from '@/theme-interface'

const {
  documentPaymentDrawer: {
    summary,
    labels,
  },
} = lang

const useStyles = makeStyles((theme: ThemeInterface) => ({
  content: {
    padding: CssHelper.px(30, 30, 0, 30),
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    height: CssHelper.percent(100),
  },
  qrCode: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 auto',
    justifyContent: 'center',
    border: theme.border,
    borderColor: theme.primary,
    borderWidth: 2,
    borderRadius: 5,
    width: 260,
    padding: 20,
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    '& label': {
      marginBottom: 10,
    },
    '& span': {
      marginBottom: 30,
    },
  },
  summaryField: {
    display: 'flex',
    flexDirection: 'column',
  },
  grow: {
    flexGrow: 1,
    maxWidth: 200,
  },
  intro: {
    margin: CssHelper.px(0, 0, 30),
  },
}))

interface QRPaymentSummaryProps {
  formData
}

const QRPaymentSummary = ({ formData }: QRPaymentSummaryProps) => {
  const classes = useStyles()
  const {
    accountHolder,
    iban,
    bic,
    totalAmount,
    purpose,
  } = formData

  const value = `BCD
001
1
SCT
${bic}
${accountHolder}
${iban}
EUR${totalAmount}


${purpose.replace(/(\r\n|\n|\r)/gm, ' ')}`

  return (
    <div className={classes.content}>
      <div>
        <div className={classes.row}>
          <div className={classes.summaryField}>
            <label>{labels.accountHolder}</label>
            <span>{accountHolder}</span>
          </div>
        </div>
        <div className={classes.row}>
          <div className={classes.summaryField}>
            <label>{labels.iban}</label>
            <span>{iban}</span>
          </div>
          <div className={classes.summaryField}>
            <label>{labels.bicSummary}</label>
            <span>{bic}</span>
          </div>
          <div className={classes.summaryField}>
            <label>{labels.totalAmount}</label>
            <span><b>{formatMoney(totalAmount, {
              symbol: '€',
              precision: 2,
              decimal: ',',
              thousand: '.',
            })}</b></span>
          </div>
          <div className={classes.row}>
            <div className={clsx(classes.summaryField, classes.grow)}>
              <label>{labels.purpose}</label>
              <span>{purpose}</span>
            </div>
          </div>
        </div>
      </div>
      <span className={classes.intro}>{summary}</span>
      <div className={classes.qrCode}>
        <QRCode size={220} value={value} level='Q' />
      </div>
    </div>
  )
}

export default QRPaymentSummary
